import gps from './gps';
import rpm from './rpm';
import temperature from './temperature';
import ae from './ae';
import flowmeter from './flowmeter';
import limitswitch from './limitswitch';
import gateway from './gateway';
import power from './power';

export default {
  gps, rpm, temperature, ae, flowmeter, limitswitch, gateway, power,
};
